import {formatter, request} from '@/utils/request';

export namespace CustType {
  export const Path = {
    Query: '/expenseapi/custType/query',
    Export: '/expenseapi/custType/export',
    Get: '/expenseapi/custType/get',
    Search: '/expenseapi/custType/search',
    QueryForSheet: '/expenseapi/custType/queryForSheet',
    AjaxSearch: '/expenseapi/custType/ajaxSearch',
    Post: '/expenseapi/custType/post',
  };

  export async function query(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<API.CustTypeQueryPo>>(Path.Query, formatter(options));
  }

  export async function exportEx(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<API.CustTypeQueryPo>>(Path.Export, formatter(options));
  }

  export async function get(id: number) {
    const options = {
      method: 'GET',
      body: {
        id
      },
    };
    return request<API.ResponseResult<API.CustType>>(Path.Get, formatter(options));
  }

  export async function search(body: API.CustTypeSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.CustType[]>>(Path.Search, formatter(options));
  }

  export async function queryForSheet(body: API.CustTypeSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.CustTypeSheetPo[]>>(Path.QueryForSheet, formatter(options));
  }

  export async function ajaxSearch(body: API.CustTypeSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.CustType[]>>(Path.AjaxSearch, formatter(options));
  }

  export async function post(body: API.CustType) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.CustType>>(Path.Post, formatter(options));
  }
}
